import React from "react"
import CloudBrowserContentDesktop from "../desktop/CloudBrowserContentDesktop"
import { useCloudProviderContext } from "../hooks/useCloudProviderContext"
import CloudBrowserContentVNZ from "../vnz/CloudBrowserContentVNZ"

interface Props {
  isMobile: boolean
}

const CloudBrowserContent: React.FC<Props> = ({ isMobile }) => {
  const { currentCloudProvider } = useCloudProviderContext()

  switch (currentCloudProvider) {
    case "your-device":
      return <CloudBrowserContentDesktop />
    case "verizon-cloud":
      return <CloudBrowserContentVNZ isMobile={isMobile} />
    default:
      return <CloudBrowserContentDesktop />
  }
}

export default CloudBrowserContent
